const GROUP_MEMBERSHIP = 'GROUP_MEMBERSHIP';
export const UPDATE_GROUP_MEMBERSHIP = `UPDATE_${GROUP_MEMBERSHIP}`;
export const SET_GROUP_MEMBERSHIP = `SET_${GROUP_MEMBERSHIP}`;
export const GET_GROUP_MEMBERSHIP = `GET_${GROUP_MEMBERSHIP}`;
export const ADD_GROUP_MEMBERSHIP = `ADD_${GROUP_MEMBERSHIP}`;
export const SET_GROUP_MEMBERSHIP_TO_ADD = `SET_${GROUP_MEMBERSHIP}_TO_ADD`;
export const GET_GROUP_MEMBERSHIP_HAS_ENROLLED_OR_INVITED_MEMBERS = `GET_${GROUP_MEMBERSHIP}_HAS_ENROLLED_OR_INVITED_MEMBERS`;
export const SET_GROUP_MEMBERSHIP_HAS_ENROLLED_OR_INVITED_MEMBERS = `SET_${GROUP_MEMBERSHIP}_HAS_ENROLLED_OR_INVITED_MEMBERS`;